import React from 'react';
import './About.css';

function About() {
  return (
    <section id="about" className="section-padding">
      <div className="container">
        <h2 className="section-title reveal">About Us</h2>

        <p className="description-text reveal">
          Best World HealthNext is a healthcare-focused marketing and engagement company that
          partners with pharma, medtech, and healthcare organizations to drive meaningful
          impact. We combine{' '}
          <strong>medical understanding, strategic thinking, and execution excellence</strong>{' '}
          to help brands:
        </p>

        <ul className="about__list reveal">
          <li>Build clinical credibility</li>
          <li>Engage the right stakeholders</li>
          <li>Accelerate product adoption</li>
        </ul>

        <p className="about__highlight reveal">
          We don't just create campaigns — we design{' '}
          <strong>outcome-driven engagement strategies</strong> that influence decisions
          where it matters most.
        </p>
      </div>
    </section>
  );
}

export default About;
